import { Component } from '@angular/core';
import { GridArticoliComponent } from 'src/app/shared/components/grid/grid-articoli/grid-articoli.component';

@Component({
  selector: 'app-giacenze',
  templateUrl: './giacenze.component.html',
  styleUrls: ['./giacenze.component.scss'],
  imports: [GridArticoliComponent],
  standalone: true,
})
export class GiacenzeComponent {

}

